import type { FC } from 'react'
import { DimmedDuration } from '@/shared/ui/dimmed-duration'
import { cn } from '@/utils'
import type { GroupTiming } from '../hooks/use-group-timing'

type CuesGroupDurationProps = {
  groupTiming: GroupTiming
  className?: string
}

export const CuesGroupPlannedDuration: FC<CuesGroupDurationProps> = ({
  groupTiming,
  className,
}) => {
  return (
    <DimmedDuration
      className={cn('text-sm opacity-50', className)}
      ms={groupTiming.original.duration}
    />
  )
}
